<template>
  <div class="flowmap-desc">
    <ul>
      <li>· 상세버전 : <strong>{{ getStringAfterEmptyCheck(rscPerfData.DBMS_VERSION) }}</strong></li>
      <li>· 호스트명 : <strong>{{ getStringAfterEmptyCheck(rscPerfData.DBMS_HOST) }}</strong></li>
      <li>· 기동시작 일시 :  <strong>{{ convertDateToString(rscPerfData.DBMS_UPTIME, 'YYYY-MM-DD HH:mm:ss') }}</strong></li>
    </ul>
  </div>
</template>

<script>
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WFlowMapTitle',
  // props : DB정보 (종류, 이름, IP주소, 상세버전, 호스트명, 가동시각)
  props: {
    rscPerfData: {
      type: Object,
    },
    objtypeId: {
      type: String,
    },
  },
  methods: {
    /**
     * datetime을 YYYY-MM-DD HH:mm:ss 형식으로 변경
     * @author Minyeong
     * @param  {[DateTimeFormat]} datetime 변경할 Datetime 데이터
     * @param  {[String]} format   Datetime을 변경할 표기 형식
     * @return {[String]}          format으로 변경된 String 날짜 데이터
     */
    convertDateToString(datetime, format) {
      if (isEmpty(datetime)) {
        return EMPTY_TEXT;
      }
      const stringDatetime = getDateToString(datetime, format);
      return stringDatetime;
    },
    getStringAfterEmptyCheck(value) {
      return isEmpty(value) ? EMPTY_TEXT : value;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapTitle.vue